import { render, staticRenderFns } from "./addgoodssaleout.vue?vue&type=template&id=0da03649&scoped=true&"
import script from "./addgoodssaleout.vue?vue&type=script&lang=js&"
export * from "./addgoodssaleout.vue?vue&type=script&lang=js&"
import style0 from "./addgoodssaleout.vue?vue&type=style&index=0&id=0da03649&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da03649",
  null
  
)

export default component.exports